import React from 'react';

const Shariah = () => {
  return (
    <main>
      <section className="bg-primary-light mt-5 gold_pattern px-80 py-5">
        <div className="container mt-5">
          <div className="row justify-content-center mb-5 pb-5">
            <div className="col-lg-9">
              <div className="z-index-3 text-center">
                <h2 className="main-title mb-4 w-100">Shariah Certification</h2>
                <p className="fs-18 m-0" style={{ color: 'var(--cgo-text)', textAlign: 'center' }}>
                  ComTech Gold (CGO) has received formal Shariah certification, making it one of the few gold-backed digital tokens fully certified as Shariah-compliant. This certification validates that CGO tokens are structured, issued, and traded in accordance with Islamic finance principles.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-secondary-light px-80 py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <h3 className="h3 text-primary mb-3">
                Certification Details
              </h3>
              <div className="table-responsive shadow-sm border-radius">
                <table className="table table-bordered align-middle cgo-table table22">
                  <thead>
                    <tr>
                      <th style={{ width: '35%', color: 'var(--cgo-table-head-fg)', backgroundColor: 'var(--cgo-table-head-bg)' }}>Item</th>
                      <th style={{ color: 'var(--cgo-table-head-fg)', backgroundColor: 'var(--cgo-table-head-bg)' }}>Detail</th>
                    </tr>
                  </thead>
                  <tbody style={{ color: 'var(--cgo-text)' }} className="fs-17">
                    <tr>
                      <td className="fw-semibold">Certifying Body</td>
                      <td>Amanie Advisors — International Islamic Finance Consultancy</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Type of Certification</td>
                      <td>Fatwa certifying CGO as Shariah-compliant digital gold</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Fatwa Document</td>
                      <td>
                        <a href="/assets/pdf/ComTech_Gold_Token_Shariah_Compliance_Cert.pdf" target="_blank" className="fw-bold" style={{ color: 'var(--cgo-accent)', textDecoration: 'underline' }}>
                          Download Shariah Certificate (PDF)
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Shariah Board</td>
                      <td>
                        Global Shariah Board of Amanie Advisors
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Periodic Review</td>
                      <td>Shariah compliance is reviewed periodically to ensure ongoing adherence</td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Compliance Scope</td>
                      <td>Token structure, gold backing, custody arrangements, and redemption process</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="h3 text-primary mt-5 mb-3">
                Why Shariah Compliance Matters
              </h3>
              <p className="fs-18 mb-4" style={{ color: 'var(--cgo-text)' }}>
                Gold has long been a cornerstone of Shariah-compliant wealth preservation. CGO extends this tradition to the digital age:
              </p>
              <ul className="fs-18 mb-5 list-unstyled" style={{ color: 'var(--cgo-text)' }}>
                <li className="mb-3 d-flex align-items-start">
                  <i className="fas fa-check-circle me-3 mt-1" style={{ color: 'var(--cgo-accent)' }}></i>
                  <span><strong style={{ color: 'var(--cgo-accent)' }}>No riba (interest):</strong> CGO tokens represent ownership of physical gold, not a debt instrument</span>
                </li>
                <li className="mb-3 d-flex align-items-start">
                  <i className="fas fa-check-circle me-3 mt-1" style={{ color: 'var(--cgo-accent)' }}></i>
                  <span><strong style={{ color: 'var(--cgo-accent)' }}>Tangible asset backing:</strong> Every CGO token is backed by real, allocated physical gold (1g per token)</span>
                </li>
                <li className="mb-3 d-flex align-items-start">
                  <i className="fas fa-check-circle me-3 mt-1" style={{ color: 'var(--cgo-accent)' }}></i>
                  <span><strong style={{ color: 'var(--cgo-accent)' }}>Transparent pricing:</strong> Gold price is pegged to international market rates with no hidden markups</span>
                </li>
                <li className="mb-3 d-flex align-items-start">
                  <i className="fas fa-check-circle me-3 mt-1" style={{ color: 'var(--cgo-accent)' }}></i>
                  <span><strong style={{ color: 'var(--cgo-accent)' }}>No gharar (uncertainty):</strong> Token structure and redemption terms are clearly defined and documented</span>
                </li>
                <li className="mb-3 d-flex align-items-start">
                  <i className="fas fa-check-circle me-3 mt-1" style={{ color: 'var(--cgo-accent)' }}></i>
                  <span><strong style={{ color: 'var(--cgo-accent)' }}>Halal custody:</strong> Physical gold is held in compliant, segregated, insured vault arrangements</span>
                </li>
              </ul>

              <h3 className="h3 text-primary mt-5 mb-4">
                Certification Statement
              </h3>
              <div className="p-4 border shadow-sm border-radius mb-5" style={{ backgroundColor: 'var(--cgo-surface)', borderColor: 'var(--cgo-border)' }}>
                <p className="fs-18 fst-italic mb-3" style={{ color: 'var(--cgo-text)', lineHeight: '1.6' }}>
                  "ComTech Gold (CGO) has been reviewed and certified by Amanie Advisors as Shariah-compliant. The token structure, gold backing, and operational procedures meet the requirements of Islamic finance principles as determined by our Shariah board. Periodic reviews are conducted to ensure ongoing compliance."
                </p>
                <div className="text-end">
                  <span className="fw-bold fs-18" style={{ color: 'var(--cgo-accent)' }}>Amanie Advisors</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Shariah;
